import {createClientCollection} from 'lib/client'

const Regions = createClientCollection('regions')

export default Regions
